import '../item.scss';
import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ItemImage = ({
	modifiers,
	className,
	image,
	title,
	text,
	...otherProps
}) => {
	const baseClass = 'item-image';
	const defaultClass = 'item';

	const rootClass = cx(baseClass, className, defaultClass, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	return (
		<div className={rootClass} data-item {...otherProps}>
			<img src={image} alt={title || ''} loading="lazy" />
			<h5>{title}</h5>
			<p>{text}</p>
		</div>
	);
};

ItemImage.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	image: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
};

export default ItemImage;
